import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, getGlassStyle, glowMd } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Modal', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-content`]: {
        background: `${navy[900]} !important`,
        ...getGlassStyle(),
        borderRadius: 4,
        border: `1px solid ${navy[700]}`,
        boxShadow: `${glowMd}, 0 25px 50px rgba(0,0,0,0.6)`,
        // Keep content padding at 0; spacing is centralized in `global.less`.
        padding: 0,
        overflow: 'hidden',
        position: 'relative' as const,

        // 顶部荧光线
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 1,
          background: `linear-gradient(90deg, transparent, ${blue[500]}80, transparent)`,
          pointerEvents: 'none',
        },
      },

      [`${componentCls}-header`]: {
        background: 'transparent !important',
        borderBottom: `1px solid ${navy[700]}80`,

        [`${componentCls}-title`]: {
          color: `#fff !important`,
          fontWeight: 600,
        },
      },

      [`${componentCls}-body`]: {
        background: 'transparent',
      },

      [`${componentCls}-footer`]: {
        background: 'transparent !important',
        borderTop: `1px solid ${navy[700]}80`,
      },

      [`${componentCls}-close`]: {
        color: `#94a3b8 !important`,
        '&:hover': {
          color: `${blue[400]} !important`,
        },
      },
    },
  }
})
